
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M45 41.5c-1.9 0-3.4-1.7-3.1-3.7.2-1.3 1.2-2.3 2.5-2.5 2-.3 3.7 1.2 3.7 3.1 0 1.7-1.4 3.1-3.1 3.1m-3.2-20.3l5.4 6.9H38v-6.9h3.8zM20.1 41.5c-1.9 0-3.4-1.7-3.1-3.7.2-1.3 1.2-2.3 2.5-2.5 2-.3 3.7 1.2 3.7 3.1 0 1.7-1.4 3.1-3.1 3.1m18.7-21.9h-25c-2.3 0-4.1 1.8-4.1 4.1v14.7h4.1c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h12.4c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h4.1v-6.7c0-2-1.7-3.7-3.7-3.7h-1.3L43 19.4l-4.2.2z"}})])
          )
        }
      }
    